import React, { useContext, useState, useCallback, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Home from "./pages/Home";
import About from './pages/About';
import Pricing from './pages/Pricing';
import Contact from "./pages/Contact";
import SocialMedia from './pages/SocialMedia';
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard"
import AuthLogin from "./profile/auth-login";
import AccessDenied from "./pages/AccessDenied"
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost"; // You'll need to create this component
import LoggedInBlogs from "./pages/LoggedInBlogs";
import Learn from "./pages/Learn";
import Books from "./pages/Books";
import LiveCharts from "./pages/LiveCharts";
import TotalTermsAndConditions from "./pages/TotalTermsAndConditions";
import SubmitIdea from "./pages/SubmitIdea";
import CreateBlog from "./pages/CreateBlog";
import Videos from "./pages/Videos";
import HowToStart from "./pages/HowToStart";
import Podcasts from "./pages/Podcasts";
import Strategies from "./pages/Strategies";
import Advanced from "./pages/Advanced";
import Signup from "./pages/Signup";
import MyAccount from "./pages/MyAccount";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ReferFriend from "./pages/ReferFriend";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminCharts from "./pages/AdminCharts";
import AdminRoute from "./components/AdminRoute";
import NotFound from "./pages/NotFound";

const AppRoutes = () => {
  const ctx = useContext(AuthLogin);
  const { pathname } = useLocation();
  // Blog post routes are registered only after the fetch below settles, so hold
  // the catch-all on /blogs/* until then instead of flashing "Page not found".
  const [blogsSettled, setBlogsSettled] = useState(false);

  const [blogItems, setBlogs] = useState([
    { title: 'Blog post title', created_at: '2024-03-20', author: 'Author Name', likes: 156, contentBlocks: null },
    { title: 'Another blog post', created_at: '2024-03-19', author: 'Author Name', likes: 342, contentBlocks: null },
    { title: 'Interesting article', created_at: '2024-03-18', author: 'Author Name', likes: 89, contentBlocks: null },
    { title: 'Tech news update', created_at: '2024-03-17', author: 'Author Name', likes: 267, contentBlocks: null },
    { title: 'Latest developments', created_at: '2024-03-16', author: 'Author Name', likes: 178, contentBlocks: null },
    { title: 'Industry insights', created_at: '2024-03-15', author: 'Author Name', likes: 445, contentBlocks: null },
  ]);

  const fetchBlogsHandler = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/getallblogs`);
      const data = await response.json();
      // console.log(data);
      if (!response.ok) {
        throw new Error();
      }
  
      const loadedBlogs = [];
  
      for (const key in data) {
        // Fetch content blocks for this blog
        const blocksResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/getBlogContent/${data[key].id}`
        );
        const blocksData = await blocksResponse.json();
  
        loadedBlogs.push({
          id: data[key].id,
          title: data[key].title,
          created_at: new Date(data[key].created_at).toLocaleDateString(),
          author: data[key].author,
          likes: data[key].likes,
          contentBlocks: blocksData
        });
      }
      // console.log(loadedBlogs);
      setBlogs(loadedBlogs);
    } catch (error) {
      console.log(error.message);
    } finally {
      setBlogsSettled(true);
    }
  }, []);

  //Render once
  useEffect(() => {
    fetchBlogsHandler();
  }, [fetchBlogsHandler]);


  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/linkedin" element={<Home />} />
      <Route path="/instagram" element={<Home />} />
      <Route path="/youtube" element={<Home />} />
      <Route path="/x" element={<Home />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword/>}/>
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/About" element={<About />} />
      <Route path="/Pricing" element={<Pricing/>} />
      <Route path="/Contact" element={<Contact/>} />
      <Route path="/SocialMedia" element={<SocialMedia />} />
      <Route path="/my-dashboard" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Dashboard /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/my-account" element={ctx.isLoggedIn? <MyAccount/> : <AccessDenied />} />
      <Route path="/add-charts" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Navigate to="/my-dashboard?addCharts=1" replace /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/blogged-in" element={ctx.isLoggedIn? (ctx.isSubscribed ? <LoggedInBlogs /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/learn" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Learn /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/how-to-start" element={ctx.isLoggedIn? (ctx.isSubscribed ? <HowToStart /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/books" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Books /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/videos" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Videos /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/podcasts" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Podcasts /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/strategies" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Strategies /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/advanced" element={ctx.isLoggedIn? (ctx.isSubscribed ? <Advanced/> : <MyAccount/>) : <AccessDenied />} />      
      <Route path="/live-charts" element={ctx.isLoggedIn? (ctx.isSubscribed ? <LiveCharts /> : <MyAccount/>) : <AccessDenied />} />
      <Route path="/blogs" element={<Blogs/>} />
      <Route path="/terms-and-conditions" element={<TotalTermsAndConditions/>} />
      <Route path="/submit-idea" element={<SubmitIdea/>}/>
      <Route path="/create-blog" element={ctx.isLoggedIn & ctx.role === 'admin' ? <CreateBlog/> : <AccessDenied />} />
      <Route path="/refer-a-friend" element={ctx.isLoggedIn ? <ReferFriend /> : <AccessDenied />} />
      {/* AdminRoute redirects non-admins here */}
      <Route path="/access-denied" element={<AccessDenied />} />
      
      {/* Admin Panel Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
      <Route path="/admin/charts" element={<AdminRoute><AdminCharts /></AdminRoute>} />
      
      {/* Dynamic blog post routes */}
      {blogItems.map(blog => (
        <Route
          key={blog.title}
          path={`/blogs/${blog.title.replace(/ /g, '-')}`}
          element={<BlogPost blogData={blog} />}
        />
      ))}

      <Route
        path="*"
        element={blogsSettled || !pathname.startsWith('/blogs/') ? <NotFound /> : null}
      />
    </Routes>
  );
};

export default AppRoutes;